import { combineReducers } from 'redux'

// Reducers
import packageAssemblyReducer from "./components/package-assembly/package-assembly-reducer"

const rootReducer = combineReducers({
    packageAssemblyReducer,
})

export default rootReducer